import {
  AuthenticationResult,
  EventMessage,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

/**
 * Instancia unica de MSAL.
 *
 * Vive en su propio modulo (y no en `main.tsx` como en el proyecto `frontend`)
 * para evitar el import circular `main -> App -> services/api -> main`.
 */
export const msalInstance: PublicClientApplication = new PublicClientApplication(
  msalConfig
);

// al recargar la pagina MSAL ya tiene la cuenta en sessionStorage, pero no la
// marca como activa: hay que reponerla para que acquireTokenSilent funcione
const accounts = msalInstance.getAllAccounts();

if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    msalInstance.setActiveAccount(payload.account);
  }
});
